import Vue from "vue";

import {PersonnelService,} from "../../common/api.service";
import {CANCEL_PERSON_TEAM_EDIT_STATE, DELETE_TEAM, FETCH_PERSON_TEAM, SAVE_PERSON_TEAM, SAVE_TEAM, UPDATE_TEAM,} from "./actions.js";
import {
    FETCH_PERSON_TEAM_END,
    LOAD_PERSON_TEAM_TO_EDIT,
    RESET_DEFAULT_PERSON_TEAM_TO_EDIT,
    RESET_DEFAULT_TEAM_TO_EDIT,
    TOGGLE_EDIT_PERSON_TEAM_DIALOG,
    TOGGLE_PERSON_TEAM_EDIT_STATE,
    UPDATE_NEW_PERSON_TEAM,
    UPDATE_PERSON_TEAM_FIELD
} from "./mutations.js";
import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const getDefaultState = () => {
    return {
        personTeam: {
            teamId: undefined
        },
        personTeamList: [],
        editPersonTeam: {
            fiscalYear: 2019,
            carriedOver: 0,
            yearlyEntitlement: 0,
            specialAllowance: 0,
            comments: '',
            holidayPeriod: 1,
        },
        defaultPersonTeam: {
            fiscalYear: 2019,
            carriedOver: 0,
            yearlyEntitlement: 0,
            specialAllowance: 0,
            comments: '',
            holidayPeriod: 1,
        },
        editPersonTeamDialog: false,
    }
};

const state = getDefaultState();

const getters = {
    editPersonTeamId(state) {
        if (state.editPersonTeam !== undefined) {
            return state.editPersonTeam.personId;
        }
    },
    editPersonTeamDialog(state) {
        return state.editPersonTeamDialog;
    },
    personTeam(state) {
        return state.personTeam;
    },
    // editedItem(state)
    // {
    //     return state.editedItem;
    // },
    editStatePersonTeam(state) {
        return state.editStatePersonTeam;
    },
};

const actions = {
    [FETCH_PERSON_TEAM]({commit}, personId) {
        if (personId == undefined) {
            return false;
        }
        return PersonnelService.getPersonTeam(personId)
            .then(({data}) => {
                commit(FETCH_PERSON_TEAM_END, data);
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to fetch teams'});
            });
    },
    [CANCEL_PERSON_TEAM_EDIT_STATE]({commit, dispatch}, params) {
        dispatch(FETCH_PERSON_TEAM, params.personId);
        commit(TOGGLE_PERSON_TEAM_EDIT_STATE, params.field);
    },
    [SAVE_TEAM]({state, commit, dispatch}, personId) {
        state.editPersonTeam.personId = personId;
        return PersonnelService.savePersonTeam(state.editPersonTeam)
            .then(({data}) => {
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                commit(RESET_DEFAULT_TEAM_TO_EDIT);
                dispatch(FETCH_PERSON_TEAM, personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to save team'});
            });
    },

    [UPDATE_TEAM]({commit, dispatch}, params) {
        return PersonnelService.updatePersonTeam(state.editPersonTeam)
            .then(({data}) => {
                commit(RESET_DEFAULT_TEAM_TO_EDIT);
                dispatch(FETCH_PERSON_TEAM, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update team'});
            });
    },

    [DELETE_TEAM]({commit, dispatch}, params) {
        return PersonnelService.deletePersonTeam(params.personTeamId)
            .then(({data}) => {
                dispatch(FETCH_PERSON_TEAM, params.personId);
                return data;
            })
            .catch(error => {
                Vue.rollbar.error(error);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to delete teams'});
            });
    },

    // Update
    [SAVE_PERSON_TEAM]({dispatch, commit}) {
        return PersonnelService.updatePersonTeam(state.editPersonTeam)
            .then(({data}) => {
                // commit(TOGGLE_PERSON_TEAM_EDIT_STATE, params.field);
                commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
                dispatch(FETCH_PERSON_TEAM, state.editPersonTeam.personId);
                return data;
            });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_EDIT_PERSON_TEAM_DIALOG](state) {
        state.editPersonTeamDialog = !state.editPersonTeamDialog;
    },


    [RESET_DEFAULT_PERSON_TEAM_TO_EDIT](state) {
        state.editPersonTeam = state.defaultPersonTeam;
    },
    [LOAD_PERSON_TEAM_TO_EDIT](state) {
        state.editPersonTeam = state.personTeam;
    },


    [TOGGLE_PERSON_TEAM_EDIT_STATE](state, field) {
        state.editStatePersonTeam[field] = !state.editStatePersonTeam[field];
    },
    [UPDATE_PERSON_TEAM_FIELD](state, data) {
        state.editPersonTeam[data.field] = data.value;
    },
    [UPDATE_NEW_PERSON_TEAM](state, data) {
        if (data.objectKey !== undefined) {
            state.editPersonTeam[data.objectKey][0][data.key] = data.value;
        } else {
            state.editPersonTeam[data.key] = data.value;
        }
    },
    [FETCH_PERSON_TEAM_END](state, data) {
        state.personTeam = data[0];
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
